export default "__VITE_ASSET__BloLE_a3__"